import './style.css'

export const Header = () => {
    return (
        <div className='Header'>
            <div>
                <div>
                    <div className='Header__textblock_first'>Cпустя целый год</div>
                </div>
                <div className='Header__textblock_second'>
                    Никита и Юлия
                </div>
                <div className='Header__textblock_third'>
                    Приглашают на свадьбу
                </div>
            </div>
        </div>
    )
}
